// @flow

import OrderItemPrices from './OrderItemPrices'

export default OrderItemPrices
